import { render, staticRenderFns } from "./DeferButton.vue?vue&type=template&id=315226ba&scoped=true&"
import script from "./DeferButton.vue?vue&type=script&lang=js&"
export * from "./DeferButton.vue?vue&type=script&lang=js&"
import style0 from "./DeferButton.vue?vue&type=style&index=0&id=315226ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315226ba",
  null
  
)

export default component.exports